import type { Role } from 'types/role';

export default function mapRoleToLabel(role: Role): string | undefined {
  switch (role) {
    case 'front-desk':
      return 'Front Desk';
    case 'manager':
      return 'Manager';
    case 'stylist':
      return undefined;
    default:
      return role;
  }
}
